import VisaIcon from './VisaIcon';
import MastercardIcon from './MastercardIcon';
import AmexIcon from './AmexIcon';
import DiscoverIcon from './DiscoverIcon';
import GenericCardIcon from './GenericCardIcon';
import PayPalIcon from './PayPalIcon';
import PayPalBrandmark from './PayPalBrandmark';
import type { IconProps } from './IconProps';

export {
  VisaIcon,
  MastercardIcon,
  AmexIcon,
  DiscoverIcon,
  GenericCardIcon,
  PayPalIcon,
  PayPalBrandmark,
};

// Card brand type map
const brandIcons: Record<string, React.FC<IconProps>> = {
  visa: VisaIcon,
  mastercard: MastercardIcon,
  'master-card': MastercardIcon,
  'american-express': AmexIcon,
  amex: AmexIcon,
  discover: DiscoverIcon,
};

export interface CardBrandIconProps {
  cardType: string | null;
  className?: string;
  bordered?: boolean;
}

export function CardBrandIcon({ cardType, className = 'w-10 h-7', bordered }: CardBrandIconProps) {
  const Icon = cardType ? brandIcons[cardType] || GenericCardIcon : GenericCardIcon;

  let isBordered = false;
  if (typeof bordered === 'undefined') {
    isBordered = cardType === null || typeof cardType === 'undefined';
  } else {
    isBordered = bordered;
  }

  return (
    <div className={`transition-opacity duration-200 ${className}`}>
      <Icon className="w-full h-full" bordered={isBordered} />
    </div>
  );
}
